'use client'

import { useContext, useEffect, useRef, useState } from "react";
import { DeviceContext } from "@/context/deviceContext";
import MobileNav from "@/components_mobile/navigation/mobileNav";
import MoBanner from "@/components_mobile/banner/moBanner";

import NewsList from "@/components_mobile/side_board/sports_news";
import TotoList from "@/components_mobile/side_board/toto";
import GlobalTopGame from "@/components_mobile/side_board/global_top_game";
import { BannerContext } from "@/context/bannerContext";
import SportsTeamGame from "@/components_mobile/side_board/sports_team_rank";
import LiveSportsComponent from "@/app/livesports/liveSports";
import LiveScoreComponent from "@/app/livescore/liveScore";
import PointExchange from "@/components_mobile/side_board/point_exchange";
import PointEvent from "@/components_mobile/side_board/point_event";
import UserRank from "@/components_mobile/side_board/user_rank";
import SportsLiveRanding from "@/components_mobile/side_board/sports_live";
import YoutubeHighlight from "@/components_mobile/side_board/youtube_highlight";
import SportsAnalysisRanding from "@/components_mobile/side_board/sports_analysis";
import EventMatch from "@/components_mobile/side_board/event_match";
import SiteShare from "@/components/etc/siteShare";
import EtcBanner from "@/components_mobile/side_board/etcBanner";
import SportsLiveConfig, { LiveStreamContext, shareInfoTypes } from "./livebroadcast/_config";





export default function Home() {
    const { mobileMode } = useContext(DeviceContext)

    return (

        !mobileMode
            ? <PCRendingLayout />
            : <MobileRendingLayout />
    )
}

function PCRendingLayout() {
    return (
        <>
            <SportsLiveConfig />
        </>
    )
}
function MobileRendingLayout() {
    const {
        main_banner,
        sub_top_banner,
        sub_middle_banner,
        sub_midbtm_banner,
        sub_bottom_banner 
    } = useContext(BannerContext)
    const { DelViewUrl, setOpenWebShare, setShareInfo } = useContext(LiveStreamContext)


    const [showSpots, setshowSpots] = useState<boolean>(true);
    const [showScore, setshowScore] = useState<boolean>(false);
    const positionTopRef = useRef(false);
    function setPositionTopFlag(value: boolean) {
        positionTopRef.current = value;
        // console.log("여기", value, positionTopRef.current);
    }


    async function webShare(shareInfo: shareInfoTypes) {
        if ((navigator as any).share) {
            try {
                await (navigator as any).share(shareInfo)
                return true
            } catch (e) {
                // 사용자가 취소했을 수도 있음
                return false
            }
        }
    }



    return (
        <>
            <MoBanner banners={main_banner} />

            {/* 아이콘영역 */}
            {/* <MobileNav /> */}

            {/* <>
                <PageTitle>"To Day 한줄 이슈"</PageTitle>
                <MiddleBanner bannerMap={sub_middle_banner.get(50)} />
            </> */}

            {/* 실시간중계 */}
            <SportsLiveRanding />

            <div className={`mainSepLine`}></div>

            {/* 사이트공유 배너 */}
            <div className="p-r-10 p-l-10">
                {/* <EtcBanner /> */}
                <MoBanner banners={sub_top_banner} />
            </div>

            <div className={`mainSepLine`}></div>

            {/* 유튜브 하이라이트 */}
            <YoutubeHighlight />

            <div className={`mainSepLine`}></div>

            {/* 중하단 배너 */}
            <div className="p-r-10 p-l-10">
                <MoBanner banners={sub_midbtm_banner} />
            </div>

            <div className={`mainSepLine`}></div>

            {/* 이벤트매치 */}
            <EventMatch />

            <div className={`mainSepLine`}></div>

            {/* 토토지식백과 */}
            {/* <TotoList /> */}

            {/* 포인트전환 */}
            {/* 스폰상품 */}
            <PointEvent isSwipe />
            {/* 제휴스폰 */}
            <PointExchange isSwipe />

            <div className={`mainSepLine`}></div>
            {/* <MoBanner banners={sub_middle_banner} ratio={"7 / 1"} /> */}
            <MoBanner banners={sub_middle_banner} />

            <div className={`mainSepLine`}></div>
            {/* 스포츠뉴스 */}
            {/* <NewsList /> */}

            {/* 스포츠분석 */}
            <SportsAnalysisRanding />

            <div className={`mainSepLine`}></div>

            <MoBanner banners={sub_bottom_banner} />

            {/* 수익왕/활동왕 총상금 */}
            {/* <UserRank /> */}

            {/* 실시간 인기게임 */}
            {/* <GlobalTopGame /> */}

            <div className={`mainSepLine`} ></div>


            {/* 실시간 스포츠 팀 순위 */}
            {/* <SportsTeamGame /> */}

            <div className={`iframeStickyWrapper`}>
                <div className={`iframeStickyInner`}>
                    {showSpots && <LiveSportsComponent type={"small"} setshowSpots={setshowSpots}
                        setshowScore={setshowScore}
                        showSpots={showSpots}
                        showScore={showScore}
                        positionTopRef={positionTopRef}
                        setPositionTopFlag={setPositionTopFlag} />}
                    {showScore && <LiveScoreComponent type={"small"} setshowSpots={setshowSpots}
                        setshowScore={setshowScore}
                        showSpots={showSpots}
                        showScore={showScore}
                        positionTopRef={positionTopRef}
                        setPositionTopFlag={setPositionTopFlag} />}
                </div>
            </div>
        </>
    )
}